var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnTtsOff = function SvgBtnTtsOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.544 20.508h1.692V13.56h2.316v-1.284h-6.3v1.284h2.292v6.948ZM15.228 20.508h1.692V13.56h2.316v-1.284h-6.3v1.284h2.292v6.948ZM22.157 20.64c2.028 0 3.024-.96 3.024-2.568 0-1.524-.78-2.076-2.124-2.436l-.72-.192c-.78-.204-1.044-.456-1.044-1.032 0-.624.456-.96 1.296-.96.924 0 1.596.228 2.148.42v-1.284c-.48-.24-1.104-.444-2.256-.444-1.896 0-2.82.972-2.82 2.388 0 1.524.756 2.1 1.944 2.412l.744.192c.876.228 1.152.468 1.152 1.116 0 .648-.456 1.08-1.5 1.08a5.916 5.916 0 0 1-2.364-.504v1.308c.576.3 1.416.504 2.52.504Z",
    fill: "#A4A7AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 10.832 12.763 10.31",
    stroke: "#fff",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10 10.832 12.763 10.31",
    stroke: "#A4A7AD",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DDDEE1"
  })));
};
export default SvgBtnTtsOff;